const cardItems = [
  {
    id: 1,
    title: '鬼灭之刃：无限城篇',
    desc: '炭治郎一行人终于抵达无限城，与上弦之鬼的终极决战即将展开。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20illustration%20of%20an%20ancient%20Japanese%20castle%20at%20night%20with%20cherry%20blossom%20petals%2C%20mysterious%20atmosphere%2C%20warm%20lantern%20light%2C%20dramatic%20shadows%2C%20Japanese%20woodcut%20style%2C%20beautiful%20composition%2C%20high%20detail&width=700&height=450&seq=card-01&orientation=landscape',
    tag: '日漫·热血',
    rating: '9.8',
    update: '每周五更新',
  },
  {
    id: 2,
    title: '凡人修仙传 第五季',
    desc: '韩立飞升灵界后的全新冒险，仙侠世界的宏大叙事继续展开。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20immortal%20cultivation%20illustration%20with%20floating%20mountains%20and%20ancient%20temples%20in%20clouds%2C%20golden%20morning%20light%2C%20mystical%20atmosphere%2C%20traditional%20Chinese%20ink%20painting%20influence%2C%20ethereal%20and%20serene%2C%20warm%20coral%20and%20cream%20tones&width=700&height=450&seq=card-02&orientation=landscape',
    tag: '国漫·仙侠',
    rating: '9.7',
    update: '每周日更新',
  },
  {
    id: 3,
    title: '葬送的芙莉莲',
    desc: '精灵魔法使芙莉莲的旅途，关于时间、生命与羁绊的治愈故事。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20of%20a%20peaceful%20countryside%20road%20with%20cherry%20blossom%20trees%2C%20warm%20golden%20afternoon%20light%2C%20gentle%20breeze%20feeling%2C%20pastoral%20European%20fantasy%20setting%2C%20soft%20and%20healing%20atmosphere%2C%20painterly%20digital%20art&width=700&height=450&seq=card-03&orientation=landscape',
    tag: '日漫·奇幻',
    rating: '9.9',
    update: '每周六更新',
  },
  {
    id: 4,
    title: '完美世界',
    desc: '石昊从石村出发，一路征战九天十地，问鼎万古仙帝之路。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20illustration%20of%20a%20hero%20standing%20on%20a%20mountain%20peak%20facing%20the%20sun%2C%20dramatic%20clouds%20and%20light%20rays%2C%20ancient%20Chinese%20fantasy%20style%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20cinematic%20scale%2C%20heroic%20atmosphere&width=700&height=450&seq=card-04&orientation=landscape',
    tag: '国漫·玄幻',
    rating: '9.6',
    update: '每周三更新',
  },
  {
    id: 5,
    title: '我推的孩子 第二季',
    desc: '星野爱久爱海在演艺圈的成长之路，娱乐圈的明暗面深度刻画。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20city%20night%20scene%20with%20neon%20lights%20and%20cherry%20blossom%20petals%2C%20stage%20spotlight%20effect%2C%20urban%20anime%20atmosphere%2C%20warm%20pink%20and%20blueish%20night%20contrast%2C%20stylish%20composition%2C%20digital%20art&width=700&height=450&seq=card-05&orientation=landscape',
    tag: '日漫·偶像',
    rating: '9.5',
    update: '每周四更新',
  },
  {
    id: 6,
    title: '斗破苍穹 年番',
    desc: '萧炎从废柴少年到炎帝的成长史诗，斗气大陆的传奇永不落幕。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20fantasy%20with%20flaming%20phoenix%20and%20ancient%20temple%2C%20dramatic%20fire%20and%20light%20effects%2C%20golden%20and%20coral%20color%20scheme%2C%20epic%20battle%20atmosphere%2C%20traditional%20Chinese%20elements%2C%20powerful%20composition&width=700&height=450&seq=card-06&orientation=landscape',
    tag: '国漫·玄幻',
    rating: '9.5',
    update: '每周日更新',
  },
  {
    id: 7,
    title: '迷宫饭',
    desc: '在迷宫中冒险的同时品尝魔物美食，脑洞大开的奇幻美食番。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20dungeon%20scene%20with%20warm%20torch%20light%2C%20stone%20walls%20and%20mysterious%20atmosphere%2C%20cooking%20theme%20elements%2C%20cozy%20underground%20tavern%20vibe%2C%20warm%20golden%20and%20amber%20lighting%2C%20charming%20illustration%20style&width=700&height=450&seq=card-07&orientation=landscape',
    tag: '日漫·美食',
    rating: '9.4',
    update: '每周五更新',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑精选的高分动漫作品，每一部都值得花时间追
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl border border-background-200/60 hover:border-accent-200/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold backdrop-blur-sm">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[10px]"></i>
                  </div>
                  {item.rating}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-calendar-line text-xs"></i>
                  </div>
                  {item.update}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}